import { Box } from '@mui/material'

// Types
import type { RevealProps } from '@/types/components/atoms/animation'

// Slides its content up into place as it scrolls into view, with CSS only (no JavaScript):
// content is fully visible from the first paint (no fade, so text contrast is never reduced),
// and browsers without scroll-driven animations simply show it in place
const RevealAtom = (props: RevealProps) => {
	// Props
	const { children, delay = 0, offset = 24 } = props

	// Variables
	// A delay starts the fade a little later in the scroll, which staggers items in a row
	const start = Math.round(delay * 40)

	return (
		<Box
			sx={{
				height: 1,
				'@keyframes revealIn': { from: { translate: `0 ${offset}px`, scale: '0.98' }, to: { translate: '0 0', scale: '1' } },
				'@supports (animation-timeline: view())': {
					'@media (prefers-reduced-motion: no-preference)': {
						animation: 'revealIn linear both',
						animationTimeline: 'view()',
						animationRange: `entry ${start}% entry ${Math.min(start + 60, 100)}%`
					}
				}
			}}
		>
			{children}
		</Box>
	)
}

export default RevealAtom
